import React from 'react';
import { Spin, Row } from 'antd';
import classnames from 'classnames';
import styles from './cms.module.scss';


import Node from './Node';

const renderNode = ({ Component, ...props }) => (
  <Row
    className={classnames(
      styles.cms__row,
      styles[`cms__row--${props.type}`],
    )}
  >
    <Component {...props} />
  </Row>
);

export const WagtailBody = ({ title, body }) => (
  body
    ? (
      <div className={styles.cms}>
        <h1 className={styles['cms__main-title']}>{title}</h1>
        <Node blocs={body} headingLevel={1}>{renderNode}</Node>
      </div>
    )
    : <div className={styles.cms__loading}><Spin /></div>
);

export default WagtailBody;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/index.js